import { apiGetList, apiCreate, apiGetOne } from './ApiBaseActions';
export const API_GET_LIST_PROFFIT_SEARCH_SLIDE = 'API_GET_LIST_PROFFIT_SEARCH_SLIDE';
export const API_GET_LIST_PROFFIT_SEARCH_SLIDE_SUCCESS = 'API_GET_LIST_PROFFIT_SEARCH_SLIDE_SUCCESS';
export const API_GET_ONE_PROFFIT_SEARCH_SLIDE_VIEW = 'API_GET_ONE_PROFFIT_SEARCH_SLIDE_VIEW';
export const API_GET_LIST_PROFFIT_SEARCH_SLIDE_FOLDER = 'API_GET_LIST_PROFFIT_SEARCH_SLIDE_FOLDER';
export const API_GET_LIST_PROFFIT_SEARCH_SLIDE_FOLDER_SUCCESS = 'API_GET_LIST_PROFFIT_SEARCH_SLIDE_FOLDER_SUCCESS';
export const API_GET_LIST_PROFFIT_SEARCH_SLIDE_RECEIVE = 'API_GET_LIST_PROFFIT_SEARCH_SLIDE_RECEIVE';
export const API_GET_LIST_PROFFIT_SEARCH_SLIDE_RECEIVE_SUCCESS = 'API_GET_LIST_PROFFIT_SEARCH_SLIDE_RECEIVE_SUCCESS';
export const API_GET_LIST_PROFFIT_SEARCH_SLIDE_PLUCK_ONE = 'API_GET_LIST_PROFFIT_SEARCH_SLIDE_PLUCK_ONE';
export const API_GET_LIST_PROFFIT_SEARCH_SLIDE_PLUCK_ONE_SUCCESS = 'API_GET_LIST_PROFFIT_SEARCH_SLIDE_PLUCK_ONE_SUCCESS';
export const API_GET_LIST_PROFFIT_SEARCH_SLIDE_LIKENESS = 'API_GET_LIST_PROFFIT_SEARCH_SLIDE_LIKENESS';
export const API_GET_LIST_PROFFIT_SEARCH_SLIDE_LIKENESS_SUCCESS = 'API_GET_LIST_PROFFIT_SEARCH_SLIDE_LIKENESS_SUCCESS';
/**
 * 検索の実行
 * @param params
 * @param meta
 * @returns {{payload: {data: *}, meta: *&{cancelPrevious: boolean, apiPath: *, fetch: string, type: *}, type: *}}
 */
export const apiGetListProffitSearchSlide = (params, meta) => apiCreate(API_GET_LIST_PROFFIT_SEARCH_SLIDE, '/proffit_search/slide/search', params, meta);
/**
 * 検索結果の閲覧
 * @param uuid
 * @param meta
 * @returns {{payload: {}, meta: *&{cancelPrevious: boolean, apiPath: *, fetch: string, type: *}, type: *}}
 */
export const apiGetOneProffitSearchSlideView = (uuid, meta) => apiGetOne(API_GET_ONE_PROFFIT_SEARCH_SLIDE_VIEW, `/proffit_search/slide/search/${uuid}/view`, meta);
/**
 * フォルダ内の検索の実行
 * @param uuid
 * @param params
 * @param meta
 * @returns {{payload: {data: *}, meta: *&{cancelPrevious: boolean, apiPath: *, fetch: string, type: string}, type: string}}
 */
export const apiGetListProffitSearchFolder = (uuid, params, meta) => apiCreate(API_GET_LIST_PROFFIT_SEARCH_SLIDE_FOLDER, `/proffit_search/slide/search_folder/${uuid}`, params, meta);
/**
 * 受領内の検索の実行
 * @param uuid
 * @param params
 * @param meta
 * @returns {{payload: {data: *}, meta: *&{cancelPrevious: boolean, apiPath: *, fetch: string, type: string}, type: string}}
 */
export const apiGetListProffitSearchReceive = (uuid, params, meta) => apiCreate(API_GET_LIST_PROFFIT_SEARCH_SLIDE_RECEIVE, `/proffit_search/slide/search_receive/${uuid}`, params, meta);
/**
 * 共有内の検索の実行
 * @param uuid
 * @param params
 * @param meta
 * @returns {{payload: {data: *}, meta: *&{cancelPrevious: boolean, apiPath: *, fetch: string, type: string}, type: string}}
 */
export const apiGetListProffitSearchShare = (uuid, params, meta) => apiCreate(API_GET_LIST_PROFFIT_SEARCH_SLIDE_RECEIVE, `/proffit_search/slide/search_share/${uuid}`, params, meta);
/**
 * スライドの複数取得の実行
 * @param params
 * @param meta
 * @returns {{payload: {data: *}, meta: *&{cancelPrevious: boolean, apiPath: *, fetch: string, type: string}, type: string}}
 */
export const apiGetListProffitSearchSlidePluck = (params, meta) => apiCreate(API_GET_LIST_PROFFIT_SEARCH_SLIDE_PLUCK_ONE, '/proffit_search/slide/pluck', params, Object.assign(Object.assign({}, meta), { ids: params.ids }));
/**
 * 類似スライドの取得の実行
 * @param ignoreSlideUuid
 * @param tags
 * @param meta
 * @returns {{payload: {params: *}, meta: *&{cancelPrevious: boolean, apiPath: *, fetch: string, type: *}, type: *}}
 */
export const apiGetListProffitSearchSlideLikeness = (ignoreSlideUuid, tags, meta) => apiGetList(API_GET_LIST_PROFFIT_SEARCH_SLIDE_LIKENESS, '/proffit_search/slide/likeness', { ignoreSlideUuid, tags }, meta);
